import { useQuery } from '@tanstack/react-query';
import config from '../../../../../../config/config';
import Fetch from '../../../../../../util/core/Fetch';

const useHouseHoldStatus = () => {
    return useQuery({
        queryKey: ['household-status'],
        queryFn: async () => {
            return await Fetch.post(
                config.endpoints.backend + 'governanceroom/esus/householdstatus',
                {}
            );
        },
        staleTime: Infinity
    });
};

export default useHouseHoldStatus;